import axios from "axios";
import store from '@/store'
import errorCode from '@/utils/errorCode'
import { getCookie } from "@/utils/cookie";
import { Notification, MessageBox, Message } from 'element-ui'

// 是否显示重新登录
export let isRelogin = { show: false };

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 添加基础URL
  timeout: 30000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = getCookie("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // 检查用户权限 - 只有ID为1的用户才能访问/admin路径
    const userId = store.getters.id;
    if (config.url && config.url.startsWith('/admin') && userId && userId !== 1) {
      Message({ message: '权限不足，您没有访问权限', type: 'error' });
      location.href = '/';
      return Promise.reject('权限不足');
    }
    
    return config;
  },
  (error) => {
    console.error("请求错误:", error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.message || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
      return res.data
    }
    if (code === 401) {
      if (!isRelogin.show) {
        isRelogin.show = true;
        MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', { confirmButtonText: '重新登录', cancelButtonText: '取消', type: 'warning' }).then(() => {
          isRelogin.show = false;
          store.dispatch('LogOut').then(() => {
            location.href = '/login';
          })
      }).catch(() => {
        isRelogin.show = false;
      });
    }
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
      Message({ message: msg, type: 'error' })
      return Promise.reject(new Error(msg))
    } else if (code === 601) {
      Message({ message: msg, type: 'warning' })
      return Promise.reject('error')
    } else if (code !== 200) {
      Notification.error({ title: msg })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    if (error.response.data.message) {
      Message({ message: error.response.data.message, type: 'error', duration: 5 * 1000 })
      return Promise.reject(error)
    }
    let { message } = error;
    if (message == "Network Error") {
      message = "网络连接异常";
    } else if (message.includes("timeout")) {
      message = "请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = message.substr(message.length - 3) + "异常";
    }
    Message({ message: message, type: 'error', duration: 5 * 1000 })
    return Promise.reject(error)
  }
)

export default service;
